import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getCompanyDetailsByID } from 'slices/thunk';

export const useCompany = () => {
    const dispatch = useDispatch<any>();
    const [isLoading, setIsLoading] = useState(false);
    
    const companyDetails = useSelector((state: any) => state.Companies.companyDetails);
    const companyError = useSelector((state: any) => state.Companies.errors);
    
    useEffect(() => {
        // Fetch company details if not already loaded
        if (!companyDetails && !isLoading) {
            setIsLoading(true);
            const storedUser = localStorage.getItem("userDetails");
            if (storedUser) {
                const userData = JSON.parse(storedUser);
                if (userData?.company_id) {
                    dispatch(getCompanyDetailsByID(userData.company_id))
                        .finally(() => setIsLoading(false));
                } else {
                    setIsLoading(false);
                }
            } else {
                setIsLoading(false);
            }
        }
    }, [dispatch, companyDetails, isLoading]);
    
    return {
        companyDetails,
        companyLogoSquare: companyDetails?.company_logo_square,
        companyLogoWide: companyDetails?.company_logo_wide,
        companyName: companyDetails?.company_name,
        isLoading,
        error: companyError
    };
};
